module.exports = __webpack_public_path__ + "static/img/http_webhook.efd4d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/http_webhook.png
// module id = H1HR
// module chunks = 0 139